import { useEffect, useState, useRef } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Phaser from 'phaser';
import Load from '../DailyBonus/scenes/Load.js';
import DailyBonus from '../DailyBonus/scenes/DailyBonus.js';
import DailyBigBonus from '../DailyBonus/scenes/DailyBigBonus.js';
import Modal from 'react-bootstrap/Modal';
import { requestNotificationPermission } from '../../../utils/firebase';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function DailyBonusPhaser(props) {
    const [notificationsSubscribe, setNotificationsSubscribe] = useState(false);
    const phaserGameRef = useRef(null);
    const handleClose = () => props.setShow(false);
    const handleShow = () => props.setShow(true);

    let screenWidth;

    const setParentNotifications = () => {
        props.setNotifications(true);
    }

    useEffect(() => {
        setNotificationsSubscribe(props.notifications);
    }, [props.notifications]);

    useEffect(() => {
        //setNotifications(Boolean(props.notifications));
        if (!props.show) { // destroy
            if (phaserGameRef.current) {
                phaserGameRef.current.destroy(true);
                phaserGameRef.current = null;
            }
            return;
        }

        // default screen width and height
        screenWidth = window.outerWidth; // 3840 is for 16:9 ,  2532 is for 19.5:9
        let screenHeight = window.outerHeight; // 2160 is for 16:9 ,  1170 is for 19.5:9

        let gameWidth = 3840; //default to 16:9 (desktop)
        let gameHeight = 2160;
        if (screenWidth < 1200) { //mobile layout
            gameWidth = 2532;
            gameHeight = 1170;
        }

        const config = {
            type: Phaser.AUTO,
            scale: {
                mode: Phaser.Scale.FIT,
                autoCenter: Phaser.Scale.CENTER_BOTH,
                width: gameWidth,
                height: gameHeight,
            },
            transparent: true,
            fps: {
                target: 30,
            },
            dom: {
                createContainer: true,
            },
            scene: [
                Load,
                DailyBonus,
                DailyBigBonus
            ],
            parent: "phaser-bonus-container",
            physics: {
                default: 'arcade',
                arcade: {
                    gravity: { y: 0 },
                    debug: false
                }
            },
        };

        if (!phaserGameRef.current) {
            phaserGameRef.current = new Phaser.Game(config);
        }

        return () => {
            if (phaserGameRef.current) {
                phaserGameRef.current.destroy(true);
                phaserGameRef.current = null;
            }
        };
    }, [props.show]);

    return (
        <Modal
            show={props.show}
            onHide={handleClose}
            onShow={handleShow}
            centered
            size="xl"
            // fullscreen={window.outerWidth < 1200 ? 'true' : 'false'}
            dialogClassName="transparent-modal phaser-bonus-modal"
        >
            <div id="phaser-bonus-container"></div>
            <Row>
                <Col xs="3" sm="3" md="3" lg="3" xl="3">
                    {notificationsSubscribe === false && (
                    <span style={{color: '#FFFFFF', textAlign: 'center', fontSize: "2rem", verticalAlign: 'middle'}}>
                        <Form.Check
                                type="switch"
                                id="notifications1"
                                name="notifications1"
                                value="notifications1"
                                checked={notificationsSubscribe}
                                label="Enable daily reminders"
                                onChange={e => {
                                    setNotificationsSubscribe(e.target.checked);
                                    if(e.target.checked){
                                        setParentNotifications();
                                        requestNotificationPermission(true);
                                    }else{
                                        requestNotificationPermission(false);
                                    }
                                }}
                                style={{ fontSize: "1.8rem"}}
                            /></span>
                    )}
                </Col>
            </Row>
            <div className='phaser-modal-close-button' onClick={() => handleClose()}>
                <HighlightOffIcon fontSize='large' htmlColor='#FFFFFF' />
            </div>
        </Modal>
    );
}
